module.exports = __webpack_public_path__ + "img/chat_delete.4d87186.png";